import { RootState } from "..";

export const selectUnits = (state: RootState, type: string) => state.units[type]